<!--
 - Author : wanghongling.
 - Date   : 2020/12/23.
 - File   : leader.名厨亮灶食堂负责人
 -->

<template>
  <layer title="" width="326px" padding="20px 20px">
    <div style="height: 75px">
      <div class="leader-wrap" v-if="list.length>0">
        <el-avatar :size="74" :src="list[0].deptLeadAvatar?(imgUrl+list[0].deptLeadAvatar):avatar"></el-avatar>
        <div class="leader-wrap-text">
          <p>食堂负责人</p>
          <p class="leader-name">{{list[0].deptLead}}</p>
        </div>
      </div>
      <div class="no-the-data" v-if="list && list.length===0">
        <div>
          <i class="iconfont icon-suoyourenyuan dzi"></i>
          <p>暂无食堂负责人</p>
        </div>
      </div>
    </div>
  </layer>
</template>

<script>
  export default {
    name: 'leader',
    data () {
      return {
        departmentId: '',
        list: [],
        imgUrl: this.$store.getters.fileApi,
        avatar: require('../../assets/images/avatar.jpg')
      }
    },
    watch: {
      selectDeptId: {
        handler(cur) {
          this.departmentId = cur
          this.getLeader()
        },
        deep: true
      }
    },
    props: ['selectDeptId'],
    mounted() {
      if(this.departmentId) {
        this.getLeader()
      }
      this.leaderWsMsg()
    },
    methods: {
      /**
       * @author wanghongling
       * @createTime 2020/12/24
       * @description websocket监听数据
       */
      leaderWsMsg () {
        window.getLeaderInfo = e => {
          console.log(e, 'websocket监听数据')
          this.getLeader()
        }
      },
      /**
       * @Description:获取名厨亮灶食堂负责人
       * @author wanghongling
       * @createDate 2020/12/24
      */
      getLeader() {
        this.$request.deptsafeconfigLeaderListGet({departmentId: this.departmentId}).then(res => {
          console.log('获取名厨亮灶食堂负责人', res)
          this.list = res
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .leader-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
    &-text{
      padding-left: 20px;
      color: #0aaade;
      font-size: 16px;
      .leader-name{
        margin-top: 10px;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mingChu/leader.vue